/* ============================================================
   Celebration Kraft · _plugins.js
   Self-contained — drop <script src="_plugins.js"></script>
   (or ../_plugins.js from legal/) before </body> on every page.

   Analytics (GA4 / Meta Pixel) are loaded by layout/theme.liquid —
   GA4 id lives in Theme settings → Analytics. This file only adds the
   WhatsApp button and the cookie notice.
   ============================================================ */

(function () {
  'use strict';

  /* ── CONFIG ──────────────────────────────────────────────── */
  var WA_NUMBER = '919053704751';
  var WA_TEXT   = encodeURIComponent('Hi! I came across Celebration Kraft and would love to know more.');

  /* ── INJECT CSS ──────────────────────────────────────────── */
  var css = [
    /* WhatsApp floating button */
    '.ck-wa{position:fixed;bottom:24px;right:24px;width:56px;height:56px;',
    'background:#25D366;border-radius:50%;display:flex;align-items:center;',
    'justify-content:center;color:#fff;z-index:90;text-decoration:none;',
    'box-shadow:0 8px 24px rgba(37,211,102,.45);transition:.3s}',
    '.ck-wa:hover{transform:scale(1.1);box-shadow:0 14px 32px rgba(37,211,102,.55)}',
    '.ck-wa svg{width:28px;height:28px;display:block}',
    '.ck-wa-ring{position:absolute;inset:0;border-radius:50%;',
    'background:#25D366;animation:ckWaPulse 2.2s ease-out infinite;z-index:-1}',
    '@keyframes ckWaPulse{0%{transform:scale(1);opacity:.7}',
    '100%{transform:scale(1.7);opacity:0}}',

    /* Cookie consent bar */
    '.ck-cookie{position:fixed;bottom:0;left:0;right:0;',
    'background:#1A0F0B;color:#cdb389;padding:14px 28px;',
    'display:flex;align-items:center;justify-content:space-between;',
    'gap:20px;z-index:200;flex-wrap:wrap;',
    'border-top:1px solid rgba(184,137,54,.4);',
    'font-family:Inter,system-ui,sans-serif;font-size:12px;line-height:1.5}',
    '.ck-cookie p{margin:0;flex:1;min-width:180px}',
    '.ck-cookie a{color:#E1B964;text-underline-offset:2px}',
    '.ck-cookie-btns{display:flex;gap:10px;flex-shrink:0}',
    '.ck-c-ok,.ck-c-no{padding:9px 20px;font-family:inherit;font-size:11px;',
    'letter-spacing:.28em;text-transform:uppercase;font-weight:600;',
    'border-radius:4px;cursor:pointer;border:1px solid #B88936;transition:.2s}',
    '.ck-c-ok{background:#B88936;color:#1A0F0B}',
    '.ck-c-ok:hover{background:#E1B964}',
    '.ck-c-no{background:transparent;color:#cdb389}',
    '.ck-c-no:hover{color:#E1B964;border-color:#E1B964}'
  ].join('');

  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  /* ── WHATSAPP BUTTON ─────────────────────────────────────── */
  function addWhatsApp() {
    var a = document.createElement('a');
    a.href      = 'https://wa.me/' + WA_NUMBER + '?text=' + WA_TEXT;
    a.target    = '_blank';
    a.rel       = 'noopener noreferrer';
    a.className = 'ck-wa';
    a.setAttribute('aria-label', 'Chat with us on WhatsApp');
    a.innerHTML =
      '<span class="ck-wa-ring"></span>' +
      '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">' +
      '<path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15' +
      '-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475' +
      '-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52' +
      '.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207' +
      '-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372' +
      '-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2' +
      ' 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118' +
      '.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>' +
      '<path d="M12 0C5.373 0 0 5.373 0 12c0 2.123.554 4.116 1.526 5.845L.042 23.957l6.27-1.445' +
      'A11.944 11.944 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 21.933a9.898 9.898 0' +
      ' 01-5.042-1.376l-.361-.214-3.741.862.893-3.625-.236-.374A9.867 9.867 0 012.067 12' +
      'C2.067 6.496 6.496 2.067 12 2.067S21.933 6.496 21.933 12 17.504 21.933 12 21.933z"/>' +
      '</svg>';
    document.body.appendChild(a);
  }

  /* ── COOKIE CONSENT ──────────────────────────────────────── */
  var CONSENT_KEY = 'ck_consent_v1';

  function showCookieBanner() {
    var bar = document.createElement('div');
    bar.className = 'ck-cookie';
    bar.innerHTML =
      '<p>We use cookies to understand how visitors use our site. ' +
      '<a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a></p>' +
      '<div class="ck-cookie-btns">' +
      '<button class="ck-c-ok">Accept</button>' +
      '<button class="ck-c-no">Decline</button>' +
      '</div>';
    document.body.appendChild(bar);

    bar.querySelector('.ck-c-ok').addEventListener('click', function () {
      localStorage.setItem(CONSENT_KEY, 'yes');
      bar.remove();
    });
    bar.querySelector('.ck-c-no').addEventListener('click', function () {
      localStorage.setItem(CONSENT_KEY, 'no');
      bar.remove();
    });
  }

  /* ── INIT ────────────────────────────────────────────────── */
  function init() {
    addWhatsApp();
    if (!localStorage.getItem(CONSENT_KEY)) {
      showCookieBanner();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
